import DataTable from './DataTable';
import { Box } from '@mui/material';

const DataTableWrapper = ({ children: buttons, height = 500, ...props }) => {
  const buttonBoxStyle = {
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
    mt: '0.5rem',
    mb: '0.5rem',
  };
  return (
    <>
      <Box sx={buttonBoxStyle}>{buttons}</Box>
      <DataTable height={height} {...props} />
    </>
  );
};

export default DataTableWrapper;
